import styled from 'styled-components';

export const COLORSWATCH_SIZE = 18;
export const ColorSwatch = styled.div`
  width: ${COLORSWATCH_SIZE}px;
  min-width: ${COLORSWATCH_SIZE}px;
  height: ${COLORSWATCH_SIZE}px;
  border-radius: 2px;
`;
